import {createError} from '#imports';
import {BarometerApi, Configuration} from '@api';
import type {GeneralBarometer, JobBarometer, GeneralBarometerRequest, JobBarometerRequest} from '@api';
import {usePrismicDocument} from '~/composables/content/usePrismicDocument';

export function useBarometerPage(barometerRequest: GeneralBarometerRequest | JobBarometerRequest) {
    const barometerApi = new BarometerApi(new Configuration({basePath: ''}));

    const {fetchDocument: fetchPrismicTemplate} = usePrismicDocument('barometerHome');

    async function fetchGeneralBarometer(): Promise<GeneralBarometer> {
        try {
            const landingPage = await barometerApi.generalBarometer(barometerRequest);
            return landingPage;
        } catch (e) {
            throw createError('Error fetching general barometer : ' + e);
        }
    }

    async function fetchJobBarometer(): Promise<JobBarometer> {
        try {
            const landingPage = await barometerApi.jobBarometer(barometerRequest as JobBarometerRequest);
            return landingPage;
        } catch (e) {
            throw createError('Error fetching job barometer : ' + e);
        }
    }

    return {
        fetchGeneralBarometer,
        fetchJobBarometer,
        fetchPrismicTemplate,
    };
}
